"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.renderAuthType = exports.IconByType = exports.defaultAuthenticationMethods = void 0;
var react_1 = __importDefault(require("react"));
var LinkedIn_1 = __importDefault(require("@material-ui/icons/LinkedIn"));
var GTranslate_1 = __importDefault(require("@material-ui/icons/GTranslate"));
var GitHub_1 = __importDefault(require("@material-ui/icons/GitHub"));
var Facebook_1 = __importDefault(require("@material-ui/icons/Facebook"));
var Lock_1 = __importDefault(require("@material-ui/icons/Lock"));
var utils_1 = require("../../../utils");
var T = __importStar(require("../type"));
var useStyles = utils_1.makeStyles(function (theme) { return ({
    icon: {
        fontSize: '1.25rem',
        marginRight: theme.spacing(1),
        verticalAlign: 'middle'
    }
}); });
exports.defaultAuthenticationMethods = [
    { id: T.AuthenticationMethodType.Password, name: 'Password' },
    { id: T.AuthenticationMethodType.GitHub, name: 'GitHub' },
    { id: T.AuthenticationMethodType.Google, name: 'Google' },
    { id: T.AuthenticationMethodType.Facebook, name: 'Facebook' },
    { id: T.AuthenticationMethodType.LinkedIn, name: 'LinkedIn' }
];
exports.IconByType = function (_a) {
    var typeId = _a.typeId;
    var classes = useStyles();
    if (typeId === T.AuthenticationMethodType.GitHub) {
        return react_1["default"].createElement(GitHub_1["default"], { className: classes.icon });
    }
    if (typeId === T.AuthenticationMethodType.Google) {
        return react_1["default"].createElement(GTranslate_1["default"], { className: classes.icon });
    }
    if (typeId === T.AuthenticationMethodType.Facebook) {
        return react_1["default"].createElement(Facebook_1["default"], { className: classes.icon });
    }
    if (typeId === T.AuthenticationMethodType.LinkedIn) {
        return react_1["default"].createElement(LinkedIn_1["default"], { className: classes.icon });
    }
    if (typeId === T.AuthenticationMethodType.Password) {
        return react_1["default"].createElement(Lock_1["default"], { className: classes.icon });
    }
    return react_1["default"].createElement(react_1["default"].Fragment, null);
};
exports.renderAuthType = function (authType) {
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(exports.IconByType, { typeId: authType.id }),
        " ",
        authType.name));
};
